<template>
  <div class="type-navbar">
    <el-menu :default-active="activeIndex" text-color='#999999' active-text-color='#24ba58' class="el-menu-demo"
      mode="horizontal" @select="handleSelect">
      <el-menu-item v-for="item of rtype" :key="item.id+item.name" :index="item.name">{{item.name}}</el-menu-item>
    </el-menu>

  </div>
</template>

<script>
import { getDictBatch } from "@/network/resourceRequest/api";

export default {
  name: "TypeNavBar",
  data() {
    return {
      activeIndex: "全部",
      rtype: [
        { name: "全部" },
        { name: "课件" },
        { name: "教案" },
        { name: "图片" },
        { name: "视频" },
        { name: "视频课程" },
        { name: "动画" },
        { name: "音频" },
        { name: "练习" },
        { name: "其他" }
      ]
    };
  },

  methods: {
    handleSelect(tab) {
      this.$emit("selectRtype", tab);
    }
  }
};
</script>

<style lang="less" scoped>
@height: 60px;

.type-navbar {
  height: @height;
  /deep/.el-menu-item {
    font-size: 14px;
    font-weight: 400;
  }

  /deep/.el-menu-item:hover {
    color: #24ba58;
  }

  /deep/.el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: 2px solid #24ba58;
  }
}
</style>